<script>
import '@sapudex/web-components/dist/Tile.js';
import '@sapudex/web-components/dist/Link.js';
import Tooltip from '@/components/common/base/Tooltip';
import PFIECompetencyItemComponent from './PFIECompetencyItemComponent';

const urlLinks = require('@/plugins/linkUrl');

export default {
  name: 'PFIECompetencyComponent',
  data: () => ({
    faqLink: urlLinks.HELP_TEXT_LEARN_MORE.COMPETENCIES,
    competency_modal_data: {},
    competency_level: 'EXPERT',
  }),
  props: {
    ieSpecializations: { type: Array, default: () => [] },
    level: { type: String, default: () => '' },
  },
  components: {
    PFIECompetencyItemComponent,
    Tooltip,
  },
  methods: {
    toggleModal(val) {
      this.showProfileCompetencyModal = val;
    },
    openLearnMore() {
      const win = window.open(this.faqLink, '_blank');
      win.focus();
    },
  },
  computed: {
    populatedCompetencies() {
      return this.$store.state.solutionL2Store.ieCompetency
        .filter((c) => this.ieSpecializations.find((c2) => c.id === c2.id))
        .map((c) => {
          const spec = this.ieSpecializations.find((s) => s.id === c.id);
          return { ...c, name: spec.name, projectsNum: spec.projectsNum };
        })
        .sort((a, b) => a.sortOrder - b.sortOrder);
    },
    leftColumnProcesses() {
      if (!this.populatedCompetencies || this.populatedCompetencies?.length <= 1) {
        return this.populatedCompetencies ? this.populatedCompetencies : [];
      }
      const leftNum = Math.ceil(this.populatedCompetencies.length / 2);
      return this.populatedCompetencies.slice(0, leftNum);
    },
    rightColumnProcesses() {
      if (!this.populatedCompetencies || this.populatedCompetencies?.length <= 1) {
        return [];
      }
      const rightNum = Math.ceil(this.populatedCompetencies.length / 2);
      return this.populatedCompetencies.slice(rightNum);
    },
  },
};
</script>

<template>
  <div class="solution-section-title" id="competency-section-header-for-scoll">
    <div class="solution-section-title-text" automation-id="profileIEcompetencyComponent-heading">
      {{ $t("ie.competency.title") }}
    </div>
    <div
      class="solution-logo competency-level-img-container"
      automation-id="profileIEcompetencyComponent-logoContainer"
    >
      <img
        v-if="level.toUpperCase() === 'ADVANCED'"
        alt=""
        class="competency-level-img competency-level2-img"
        src="../../assets/Competency-Level2.png"
        automation-id="profileIEcompetencyComponent-logoAdvanced"
      />
      <img
        v-if="level.toUpperCase() === 'EXPERT'"
        alt=""
        class="competency-level-img competency-level3-img"
        src="../../assets/Competency-Level3.png"
        automation-id="profileIEcompetencyComponent-logoExpert"
      />
    </div>
    <Tooltip>
        <template #text>{{$t("ie.competency.helptext")}}</template>
        <template #link>
          <udex-link accessibleRole="Link" @click.prevent="openLearnMore">
            {{ $t("learn.more") }}
          </udex-link>
        </template>
    </Tooltip>
  </div>
  <div class="solution-container">
    <PFIECompetencyItemComponent :ieCompetency="leftColumnProcesses" :leftCol="true" />

    <PFIECompetencyItemComponent :ieCompetency="rightColumnProcesses" :leftCol="false" />
  </div>
</template>

<style lang="less" scoped>
.solution-section-title{
  display: flex;
  justify-content: center;
  align-items: center;
}
.solution-section-title-text {
  display: inline-block;
}
@media (max-width: 639px) {
  .solution-section-title-text {
    font-size: 20px !important;
    max-width: 198px;
  }
  .solution-section-title {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .solution-logo {
    margin-left: 4px !important;
  }
}

.solution-section-title {
  &:extend(.HeadingMediumXS-size);
  text-align: center;
  color: #000000;
}

.solution-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.solution-column {
  line-height: 75px;
  font-size: 30px;
}
.left-column {
  margin-left: 26px;
  margin-right: 26px;
}
.right-column {
  margin-left: 26px;
  margin-right: 26px;
}

.solution-logo {
  margin-left: 8px;
  margin-top: 3px;
  width: 90px;
  text-align: left;
  display: inline-block;
  position: relative;
}

.competency-level-img-container {
  position: relative;
  height: 16px;
  width: 90px;
}
.competency-level-img {
  height: 16px;
  width: 90px;
  display: block;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.profile-competency-more-text:hover,
.competency-content:hover {
  color: @color-link__hover;
  .competency-header,
  .description-text {
    color: @color-link !important;
  }
  .competency-level-img {
    padding-left: 90px;
  }
  .competency-level1-img {
    background: url("../../assets/Competency-lvl1-hover.png") no-repeat;
    background-size: 90px 16px;
  }
  .competency-level2-img {
    background: url("../../assets/Competency-lvl2-hover.png") no-repeat;
    background-size: 90px 16px;
  }
  .competency-level3-img {
    background: url("../../assets/Competency-lvl3-hover.png") no-repeat;
    background-size: 90px 16px;
  }
}
</style>
